import React from 'react';
import PropTypes from 'prop-types';

import api from '../../../../../apiSingleton';
import ContactsHidden from './ContactsHidden';
import { PAGE_TYPES } from '../../../../../consts';
import { Contacts as ContactsButton } from '../../../../Buttons';

class Contacts extends React.Component {
  constructor (props) {
    super(props);

    this.isRealtor = props.user && (props.user.getIn(['data', 'isRealtor'], false) || false);
    this.item = props.item;
    this.rawItem = props.rawItem;
    this.author = this.item.getAuthor();
    this.contact = this.item.getContact();

    this.phones = this.isRealtor
        ? this.contact.getPhones().join(',\u0020\u0020\u0020\u0020')
        : this.contact.getPhones().map((c, i) => <div className='phone-item' key={i}>{c}</div>);

    this.state = {
      show: this.isRealtor
    };

    this.showContacts = this.showContacts.bind(this);
  }

  showContacts () {
    this.setState({
      show: true
    });

    this.props.eventShowContacts(this.rawItem);

    api.announcement
      .hitContacts(this.item.getDealType(), this.item.getRealtyType(), this.item.getProperty().getId(), PAGE_TYPES.TYPE_LISTING)
      .catch(x => null);
  }

  render () {
    if (!this.author.isExist()) {
      return (
        <ContactsHidden />
      );
    }

    return (
      <td className='paper col-contacts'>
        {
          this.state.show
          ? (
            <div>
              <div className='main-param'>{this.contact.getName()}</div>
              <div className='phone-list'>{this.phones}</div>
            </div>
          )
          : <ContactsButton onClick={this.showContacts} value={this.contact.getPhones()[0]} />
        }
      </td>
    );
  }
}

Contacts.propTypes = {
  item: PropTypes.object.isRequired,
  rawItem: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,

  eventShowContacts: PropTypes.func
};

Contacts.defaultProps = {
  eventShowContacts: () => {}
};

export default Contacts;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/Contacts.jsx